import classNames from "classnames";
import { useChatContext } from "duck/ui/chat/contexts/useChatContext";
import { useFlags } from "launchdarkly-react-client-sdk";
import { useTranslation } from "react-i18next";
import GppGoodOutlinedIcon from "@mui/icons-material/GppGoodOutlined";
import ShieldOutlinedIcon from "@mui/icons-material/ShieldOutlined";

import IconButton from "features/components/IconButton";

/**
 * Applies to the next message sent; subthreads spawned by a safe-mode message inherit it.
 */
const SafeModeToggle = () => {
  const { t } = useTranslation();
  const { safeMode, setSafeMode, isStreaming, isAnySubthreadStreaming } =
    useChatContext();
  const { duckSafeMode } = useFlags();

  if (!duckSafeMode) {
    return null;
  }

  const isAgentRunning = isStreaming || isAnySubthreadStreaming;

  const label = safeMode
    ? t("duck:safe_mode_disable")
    : t("duck:safe_mode_enable");

  return (
    <IconButton
      onClick={() => setSafeMode(!safeMode)}
      color="secondary"
      size="small"
      disabled={isAgentRunning}
      aria-pressed={safeMode}
      aria-label={label}
      testId="duck-safe-mode-toggle"
      // MUI Tooltip cannot listen on a disabled button and warns about it, so
      // drop the tooltip while the toggle is disabled.
      tooltip={isAgentRunning ? undefined : t("duck:safe_mode_tooltip")}
      className={classNames({
        "!bg-blue-50 !text-blue-700": safeMode,
      })}
    >
      {safeMode ? (
        <GppGoodOutlinedIcon fontSize="small" />
      ) : (
        <ShieldOutlinedIcon fontSize="small" />
      )}
    </IconButton>
  );
};

export default SafeModeToggle;
